import { IItemRole } from "@/staticCollections/index";
import Dict from "@/staticCollections/dict";

export enum TeamPermissions {
  OnlyOfficeModule = "onlyoffice-module",
  ProtocolsModule = "protocols-module",
  IgnoreWhenTracking = "ignore-when-tracking",
}

const items: Record<TeamPermissions, IItemRole> = {
  [TeamPermissions.OnlyOfficeModule]: {
    order: 4,
    translationKey: "OnlyOffice Module",
    value: TeamPermissions.OnlyOfficeModule,
  },
  [TeamPermissions.ProtocolsModule]: {
    order: 8,
    translationKey: "Protocols Module",
    value: TeamPermissions.ProtocolsModule,
  },
  [TeamPermissions.IgnoreWhenTracking]: {
    order: 12,
    translationKey: "Exclude from Amplitude metrics",
    value: TeamPermissions.IgnoreWhenTracking,
  },
};

export default new Dict<TeamPermissions, IItemRole>(items);
